import { Grid } from '@simplywallst/ui-core';
import { MetricWrapper } from './styled';
import { Text } from '@simplywallst/ui-core';
import { Nbsp } from '@/components/nbsp';

interface Props {
  pe: 'n/a' | string;
  pb: 'n/a' | string;
  ps: 'n/a' | string;
}

export const ValuationMetricTooltip = ({ pe, pb, ps }: Props) => {
  const notProfitable = pe === 'n/a';
  return (
    <MetricWrapper
      gap="12px"
      templateRows="auto auto"
      templateColumns="auto auto"
      data-cy-id="valuation-ratio-tooltip"
    >
      <Grid column="span 2" data-cy-id="current-pe">
        <Text typography="xSmallStrong" color="spaceGray">
          PE
          <Nbsp />
          <Nbsp />
          <Text
            as="span"
            typography={notProfitable ? 'xSmallStrong' : 'xLargeStrong'}
            color="spaceGrayRGBA"
            opacity={notProfitable ? 0.5 : 1}
          >
            {notProfitable ? 'n/a (not profitable)' : pe}
          </Text>
        </Text>
        <Text typography="tiny" color="spaceGrayRGBA" opacity={0.5}>
          Price to Earnings
        </Text>
      </Grid>
      <Grid data-cy-id="current-pb">
        <Text typography="xSmallStrong" color="spaceGray">
          PB
          <Nbsp />
          <Nbsp />
          <Text as="span" typography="xLargeStrong" color="spaceGray">
            {pb}
          </Text>
        </Text>
        <Text typography="tiny" color="spaceGrayRGBA" opacity={0.5}>
          Price to Book
        </Text>
      </Grid>
      <Grid data-cy-id="current-ps">
        <Text typography="xSmallStrong" color="spaceGray">
          PS
          <Nbsp />
          <Nbsp />
          <Text as="span" typography="xLargeStrong" color="spaceGray">
            {ps}
          </Text>
        </Text>
        <Text typography="tiny" color="spaceGrayRGBA" opacity={0.5}>
          Price to Sales
        </Text>
      </Grid>
    </MetricWrapper>
  );
};
